import { useEffect } from 'react';

const SEO = ({ 
    title, 
    description, 
    canonical,
    noindex = false 
}) => {
    const siteName = 'Raw Minerals';
    const defaultDescription = 'Norges første spesialiserte importør av premium mineralvann. Vi leter frem verdens fineste vann for bevisste norske ganer.';
    const baseUrl = 'https://www.rawminerals.no';

    const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Your Hydration Partner`;
    const metaDescription = description || defaultDescription;
    const canonicalUrl = canonical ? `${baseUrl}${canonical}` : null;

    useEffect(() => {
        // Update document title
        document.title = fullTitle;

        // Update meta description
        let metaDescEl = document.querySelector('meta[name="description"]');
        if (metaDescEl) {
            metaDescEl.setAttribute('content', metaDescription);
        }

        // Update canonical
        if (canonicalUrl) {
            let canonicalEl = document.querySelector('link[rel="canonical"]');
            if (canonicalEl) {
                canonicalEl.setAttribute('href', canonicalUrl);
            }
        }

        // Update Open Graph tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        const ogDesc = document.querySelector('meta[property="og:description"]');
        const ogUrl = document.querySelector('meta[property="og:url"]');
        
        if (ogTitle) ogTitle.setAttribute('content', fullTitle);
        if (ogDesc) ogDesc.setAttribute('content', metaDescription);
        if (ogUrl && canonicalUrl) ogUrl.setAttribute('content', canonicalUrl);

        // Update Twitter tags
        const twitterTitle = document.querySelector('meta[name="twitter:title"]');
        const twitterDesc = document.querySelector('meta[name="twitter:description"]');
        
        if (twitterTitle) twitterTitle.setAttribute('content', fullTitle);
        if (twitterDesc) twitterDesc.setAttribute('content', metaDescription);

        // Handle noindex
        if (noindex) {
            let robotsMeta = document.querySelector('meta[name="robots"]');
            if (!robotsMeta) {
                robotsMeta = document.createElement('meta');
                robotsMeta.name = 'robots';
                document.head.appendChild(robotsMeta);
            }
            robotsMeta.setAttribute('content', 'noindex, nofollow');
        }
    }, [fullTitle, metaDescription, canonicalUrl, noindex]);

    return null; // This component doesn't render anything
};

export default SEO;
